export default (err, vm, info) => {
  console.log(err);
  if (err.constructor && 
    ![
      'EvalError',
      'RangeError',
      'ReferenceError',
      'SyntaxError',
      'TypeError'
    ].includes(err.constructor.name)
  ) return;

  if (process.env.VUE_ENV == 'server') {
    throw err;
  }

  console.log('Vue Error Handler: ', err);
  if (vm && vm.$router) {
    vm.$router.replace({
      name: `SomethingWrongKeepURL_${vm.$i18n.locale}`, 
      params: {'0' : vm.$route.path.split('/').slice(2).join('/')},
      query: vm.$route.query
    })
  }
}